export class Autos {
	id: number;
	idCliente: number;
	anio: number;
	placas: string;
	economico: string;
	numeroSerie: string;
	color: string;
	descripcion: string;
	imagen: string;
	modelo: string;
	estatus: number;
	imeiFk: string;
	lat: number;
	lng: number;
	estado: number;
	ignicion: number;
	velocidad: number;
	direccion: number;
	odometro: number;
	marca: string;
	fechaHoraUltimaPosicion: string;
	estaEnMovimiento: boolean;
	cliente: string;
	geocercas: Geocercas[];
	fotoOperador:string;
	nombreOperador:string;
	combustible:number;
	capacidadTanque:number;
	imeiCombustible:number;
	idEquipo:number;
}

export interface AutosCamara {
	deviceID: string,
	data: [
		{
			deviceID: string;
			location: {
				satellites: string;
				direct: string;
				speed: string;
				altitude: string;
				longitude: string;
				latitude: string;
				precision: string;
				dtu: string;
				mode: string;
			},
			mileage: {
				todayDay: string;
				total: string;
			}
		}
	],
	vehiculo: {
		id: number;
		anio: number;
		placas: string;
		economico: string;
		numeroSerie: string;
		color: string;
		descripcion: string;
		imagen: string;
		modelo: string;
		estatus: number;
		imeiFk: string;
		lat: number;
		lng: number;
		estado: number;
		ignicion: number;
		velocidad: number;
		direccion: number;
		odometro: number;
		marca: string;
		fechaHoraUltimaPosicion: string;
		estaEnMovimiento: false,
		fecha: string;
		idPosicion: number;
		idCliente: number;
	}
}


export interface Geocercas {
	id: number;
	nombre: string;
}
